var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#466AEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 36C16.25 31.0869 20.7007 27.25 26 27.25C31.2993 27.25 35.75 31.0869 35.75 36V36.75H16.25V36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 20.5C20.75 17.6005 23.1005 15.25 26 15.25C28.8995 15.25 31.25 17.6005 31.25 20.5C31.25 23.3995 28.8995 25.75 26 25.75C23.1005 25.75 20.75 23.3995 20.75 20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.5fbfac969069f7f70728841b8d025b45.svg";
export { ForwardRef as ReactComponent };